import React from "react";
import PropTypes from "prop-types";
import "./App.css";
import armylogo from "./Army_logo.png";
import airforcelogo from "./Airforce Crest.png";
import navylogo from "./Navy-crest.png";
import nttlogo from "./nttlogo.png";
import emblem from "./Ministry_of_Defence_India.png";

export default function Certificate({ receiptData, formatDate }) {
  return (
    <div className="certificate-wrapper" id="certificate-pdf">
      <div className="certificate">
        <div className="certificate-header">
          <img src={emblem} alt="Emblem" className="emblem" />
          <h2>रक्षा मंत्रालय</h2>
          <h2>MINISTRY OF DEFENCE</h2>
        </div>

        <h1 className="thank-you">Thank You</h1>
        <div className="transaction-id-floating">
          Txn ID: {receiptData?.transaction_id || "______________________"}
        </div>

        <p className="line">
          <span className="underline">
            {receiptData?.donor_name || "______________________"}
          </span>
        </p>

        <p className="line">
          For your valued contribution of Rupees{" "}
          <span className="underline">
            {receiptData?.transaction_amount || "______________________"}
          </span>{" "}
          on{" "}
          <span className="underline">
            {formatDate(receiptData?.added_on) || "______________________"}
          </span>{" "}
          to the
        </p>

        <h2 className="fund-name">
          Armed Forces Battle Casualties Welfare Fund
        </h2>
        <p className="support-text">and</p>
        <p className="support-text">
          supporting the cause of personnel killed or injured in action and
          their next of kin.
        </p>

        <div className="logos">
          <img src={armylogo} alt="Army Logo" className="logo" />
          <img src={navylogo} alt="Navy Logo" className="logo" />
          <img src={airforcelogo} alt="Airforce Logo" className="logo" />
        </div>

        <div className="receipt-poweredby">
          <span className="receipt-poweredby-text">powered by</span>
          <img
            src="https://payformservices.nttdatapay.com/logos/armedforces/adaptis-dark.webp"
            alt="NTT Data Pay Logo"
            className="receipt-poweredby-logo"
          />
        </div>
        <p className="footer">
          IHQ of MoD (Army), Adjutant General’s Branch, CW Directorate, Account
          Section, Room No 281, South Block, Delhi-110011
        </p>
        <p className="footer">
          Email - acwf.cw.281b@gmail.com, Landline - 011-23792382, Mobile - +91 7303169306
        </p>
      </div>
    </div>
  );
}

Certificate.propTypes = {
  receiptData: PropTypes.shape({
    transaction_id: PropTypes.string,
    donor_name: PropTypes.string,
    transaction_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    added_on: PropTypes.string,
  }),
  formatDate: PropTypes.func.isRequired,
};

